import { useState, lazy, Suspense } from 'react'
import { LorePanel } from '../components/LorePanel'
import { Hud } from '../components/Hud'
import { getBodyById } from '../lore'

// PixiJS is heavy, so only load it on the map screen, not the lorebook.
const SystemMap = lazy(() =>
  import('../components/SystemMap').then((m) => ({ default: m.SystemMap })),
)

/** The interactive map screen. */
export function Home() {
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const body = selectedId ? getBodyById(selectedId) : undefined

  return (
    <main className="relative h-screen w-screen overflow-hidden">
      <Suspense
        fallback={
          <div className="absolute inset-0 flex items-center justify-center text-sm text-slate-500">
            Initializing system…
          </div>
        }
      >
        <SystemMap selectedId={selectedId} onSelect={setSelectedId} />
      </Suspense>
      <Hud />
      {body && <LorePanel body={body} onClose={() => setSelectedId(null)} />}
    </main>
  )
}
